module.exports = __webpack_public_path__ + "media/images/profil blanc-0b89ba1f02966479675d361738c4bba4.svg";